import Vue from 'vue'
import Router from 'vue-router'

import '@/assets/css/reset.css'
import '@/assets/css/style.css'

Vue.use(Router)
// 缓存原型上的push函数
const originPush = Router.prototype.push
const originReplace = Router.prototype.replace
// 给原型对象上的push指定新函数函数
Router.prototype.push = function (location, onComplete, onAbort) {
  // 判断如果没有指定回调函数, 通过call调用源函数并使用catch来处理错误
  if (onComplete===undefined && onAbort===undefined) {
    return originPush.call(this, location, onComplete, onAbort).catch(() => {})
  } else { // 如果有指定任意回调函数, 通过call调用源push函数处理
    originPush.call(this, location, onComplete, onAbort)
  }
}
Router.prototype.replace = function (location, onComplete, onAbort) {
  if (onComplete===undefined && onAbort===undefined) {
    return originReplace.call(this, location, onComplete, onAbort).catch(() => {})
  } else {
    originReplace.call(this, location, onComplete, onAbort)
  }
}

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '',
    //   redirect:'/pc-home'
    // },
    // 日本官网
    {
      path:'/jpn-home',
      name:'jpn-home',
      component:()=>import('@/pages/japan/home')
    },
    {
      path:'/jpn-member',
      name:'jpn-member',
      component:()=>import('@/pages/japan/member')
    },
    {
      path:'/jpn-club',
      name:'jpn-club',
      component:()=>import('@/pages/japan/club')
    },
    // pc端的路由
    {
      path:'/pc-home',
      name:'pc-home',
      component:()=>import('@/pages/pc/home')
    },
    {
      path:'/pc-course',
      name:'pc-course',
      component:()=>import('@/pages/pc/course')
    },
    {
      path:'/pc-host',
      name:'pc-host',
      component:()=>import('@/pages/pc/host')
    },
    {
      path:'/pc-founder',
      name:'pc-founder',
      component:()=>import('@/pages/pc/founder')
    },
    // 手机端的路由
    {
      path:'/mobile-home',
      name:'mobile-home',
      component:()=>import('@/pages/mobile/home')
    },
    {
      path:'/mobile-course',
      name:'mobile-course',
      component:()=>import('@/pages/mobile/course')
    },
    {
      path:'/mobile-host',
      name:'mobile-host',
      component:()=>import('@/pages/mobile/host')
    },
    {
      path:'/mobile-founder',
      name:'mobile-founder',
      component:()=>import('@/pages/mobile/founder')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js